export default "__VITE_ASSET__3indIe3o__"